import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import Accordion from "../../../common/accordion";
import { RootState } from "../../../../store/ConfigureStore";
import TableComponent from "../../../common/TableComponent";
import EquipmentTableAddChargePump from "../../../common/equipment-table-charge-pump";
import useCalculationFacade from "../../../../facade/calculation/calculation.facade";
import useTubingFacade from "../../../../facade/calculation/calculation-input/tubing.facade";
import { useSurfaceEquipmentFacade } from "../../../../facade/calculation/calculation-output/surfaceEquipment.facade";
import { letterSpacing } from "html2canvas/dist/types/css/property-descriptors/letter-spacing";

const Controller: React.FC<{ showError: string[], setShowError: any }> = ({ showError, setShowError }) => {
  const { controllerCollapse } = useAppSelector(
    (state) => state?.collapse
  );

  const { updateMotorLoadFrequency, updateSchematicEquipmentData } = useCalculationFacade();
  const { updateHiddenSurfVSD, updateHiddenSwitchBoard, updateSurfaceControllerType } = useTubingFacade();
  const { updatePowerField, updateWeightField, updateESPEquipments, updateSelecltedVSD, updateSelectedSwitchBoard } = useSurfaceEquipmentFacade();
  const selectedSwitchBoard = useAppSelector((state: RootState) => state.tubing?.tab1Input?.hiddenSwtchBrd);
  const SelectedVSD = useAppSelector((state: RootState) => state.tubing?.tab1Input?.hiddenSurfVSD);
  const SwitchBoardList = useAppSelector((state: RootState) => state.surfaceEquipment?.SwitchBoardList);
  const VSDList = useAppSelector((state: RootState) => state.surfaceEquipment?.VSDList);
  const vsdEquipments = useAppSelector((state: RootState) => state.surfaceEquipment?.ESPEquipments);
  const equipments = useAppSelector((state: RootState) => state.surfaceEquipment?.Equipments);
  const { FetchSwitchControllerLoad, FetchVSDControllerLoad } = useAppSelector((state) => state?.surfaceEquipment);
  const controllerTypeVal = useAppSelector((state: RootState) => state.tubing?.tab1Input?.hdnCntrlTyp);
  const { customerEnabled,customerCreated } = useAppSelector((state) => state?.auth);
  const { projectReadOnly } = useAppSelector((state) => state.projectHeader);
  
  let controllerType = "VSD";

  if (controllerTypeVal === "1")
    controllerType = "Switchboard";
  else if (controllerTypeVal === "0")
    controllerType = "VSD";
  else
    controllerType = controllerType;

  const tableVSDColumns = [
    { key: "descriptionField", title: "Description", dataIndex: "descriptionField" },
    { key: "powerField", title: "Power kVA", dataIndex: "powerField" },
    { key: "current_InField", title: "Current In A", dataIndex: "current_InField" },
    { key: "current_OutField", title: "Current Out A", dataIndex: "current_OutField" },
    { key: "voltageField", title: "Voltage V", dataIndex: "voltageField" },
    { key: "phaseField", title: "Phase", dataIndex: "phaseField" },
    { key: "pulse", title: "Pulse", dataIndex: "pulse" },
    { key: "enclosure", title: "Enclosure", dataIndex: "enclosure" },
    { key: "weightField", title: "Weight", dataIndex: "weightField" },
    { key: "make", title: "Make", dataIndex: "make" },
  ];

  const tableSwitchBoardColumns = [
    { key: "description", title: "Description", dataIndex: "description" },
    { key: "control", title: "Control", dataIndex: "control" },
    { key: "voltage", title: "Voltage V", dataIndex: "voltage" },
  ];
  useEffect(() => {
    if (selectedSwitchBoard) {
      if ((FetchSwitchControllerLoad > 0 && FetchSwitchControllerLoad < 50) || FetchSwitchControllerLoad > 90) {
        if (!showError?.includes("Selected SwitchBoard not suitable for required Voltage."))
          setShowError((prevState: any) => [...prevState, "Selected SwitchBoard not suitable for required Voltage."]);
      } else {
        setShowError((prevState: any) =>
          prevState.filter((error: any) => error !== "Selected SwitchBoard not suitable for required Voltage.")
        );
      }

    }
  }
    , [FetchSwitchControllerLoad]);

  useEffect(() => {
    const SelectedVSDData = VSDList.find((x: { vsD_ID: any; }) => x.vsD_ID === SelectedVSD?.toString());
    if (SelectedVSDData) {
      if ((FetchVSDControllerLoad > 0 && FetchVSDControllerLoad < 50) || FetchVSDControllerLoad > 90) {
        if (!showError?.includes("Selected VSD not suitable for required KVA."))
          setShowError((prevState: any) => [...prevState, "Selected VSD not suitable for required KVA."]);
      } else {
        setShowError((prevState: any) =>
          prevState.filter((error: any) => error !== "Selected VSD not suitable for required KVA.")
        );
      }
    }
  }, [FetchVSDControllerLoad]);

  const { updateControllerCollapse } = useCollapseFacade();

  const handleCollapseChange = (key: boolean) => {
    updateControllerCollapse(key);
  };

  const handleControllerTypeChange = (controllerTypeValue: string) => {
    updateSurfaceControllerType(controllerTypeValue)
  };

  const handleChangeVSDEquipment = (option: any, index: number) => {
    updateESPEquipments([option]);
    updateSchematicEquipmentData();
  };

  const handleVSDClear = () => {
    updateESPEquipments([]);
    updateSchematicEquipmentData();
  };

  const [maxEquipmentLimit, setMaxEquipmentLimit] = useState<number>(4);

  const VSDClicked = (vsdid: string, powerField: number, vsdWeight: string) => {
    const selectedVSDData = VSDList.find((x: any) => x.vsD_ID === vsdid?.toString())
    if (SelectedVSD !== vsdid) {
      updateESPEquipments([]);
      updateSchematicEquipmentData();
    }
    updateHiddenSurfVSD(vsdid);
    updatePowerField(powerField);
    updateWeightField(vsdWeight);
    updateMotorLoadFrequency();
    updateSelecltedVSD(selectedVSDData);
  };

  const SwitchBoardClicked = (row: any) => {
    updateSelectedSwitchBoard(row);
    updateHiddenSwitchBoard(row?.switchBrdID);
  };

  const equipmentColumns = [
    { title: "PN", key: "pn" },
    { title: "Weight (lbs)", key: "weight" },
  ];

  return (
    <Accordion
      tooltipText="Formulas"
      title="Controller"
      link={'/help?tab=Surface-Equipment#wappertwo'}
      isOpen={controllerCollapse}
      onToggle={() => handleCollapseChange(!controllerCollapse)}
      content={<div className="px-[16px] py-[16px]">
        <div className="flex items-center mb-4 space-x-2 justify-between w-full">
          <div className="flex items-center space-x-4">
            <p className="text-neutral-25">Controller type</p>
            <div className="flex space-x-2 border border-[#4A5463] rounded-lg">
              <button
                onClick={() => ((!customerEnabled && !projectReadOnly) || (customerEnabled && customerCreated)) && handleControllerTypeChange("1")}
                className={`px-4 py-2 rounded-l-lg ${controllerType === "Switchboard"
                  ? "bg-gray-100 text-[#60BFDA]"
                  : "bg-gray-100 hover:bg-gray-200 text-white"
                  } transition-colors duration-200`}
              >
                Switchboard
              </button>
              <div className="border-r-[1px] border-darkcolor-400"></div>
              <button
                onClick={() =>((!customerEnabled && !projectReadOnly) || (customerEnabled && customerCreated)) &&  handleControllerTypeChange("0")}
                className={`px-4 py-2 rounded-r-lg ${controllerType === "VSD"
                  ? "bg-gray-100 text-[#60BFDA]"
                  : "bg-gray-100 hover:bg-gray-200 text-white"
                  } transition-colors duration-200`}
              >
                VSD
              </button>
            </div>
          </div>
          <div className="px-4 text-neutral-25 ml-auto">
            Percentage of controller load{" "}
            {(FetchSwitchControllerLoad > 0 && controllerType === "Switchboard")
              ? `${FetchSwitchControllerLoad}%`
              : (FetchVSDControllerLoad > 0 && controllerType === "VSD")
                ? `${FetchVSDControllerLoad}%`
                : ' %'}
          </div>
        </div>
        <div className="items-center mb-[20px] space-y-4 md:space-y-0 p-4">
          {controllerType === "Switchboard" ? (
            <TableComponent
              name={'switchBoard'}
              data={SwitchBoardList}
              rowsPerPage={50}
              columns={tableSwitchBoardColumns}
              clickableRows={true}
              onRowClick={(row) => SwitchBoardClicked(row)}
              emptyIcon={true}
              pagination={false}
              hiddenSwitchBoardId={selectedSwitchBoard}
              overFlowClass="overflow-auto"
            />
          ) : (

            <TableComponent
              name={'VSD'}
              data={VSDList}
              rowsPerPage={50}
              columns={tableVSDColumns}
              singleExpandMode={true}
              clickableRows={true}
              onRowClick={(row) => VSDClicked(row.vsD_ID, row.powerField, row.vsdWeight)}
              emptyIcon={true}
              pagination={false}
              hiddenVSDId={SelectedVSD}
              overFlowClass="overflow-auto"
              renderExpandedRow={(row) => row.errorMessage ? (

                <div className="p-2 text-red-500 bg-red-200 rounded">
                  {row.errorMessage}
                </div>
              ) : equipments?.length > 0 ? (
                <EquipmentTableAddChargePump
                  options={equipments.map((item: any) => {
                    return {
                      ...item,
                      label: item?.text,
                      value: item?.id,
                      weight: row?.weightField
                    };
                  })}
                  equipments={
                    vsdEquipments?.length > 0 ? vsdEquipments : [{}]
                  }
                  equipmentGridParentContainer="SRSurfaceEquipments"
                  onChange={handleChangeVSDEquipment}
                  rowLength={maxEquipmentLimit}
                  isPumpListMode={false}
                  columns={equipmentColumns}
                  onClear={handleVSDClear}
                />
              ) : (
                <></>
              )} />
          )}
        </div>

      </div>}
    />
  );
};

export default Controller;
